var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm safetyOrg-org-card",
              attrs: { title: `비상연락체계도` },
            },
            [
              _c(
                "template",
                { slot: "card-button" },
                [_c("q-btn-group", { attrs: { outline: "" } })],
                1
              ),
              _c("template", { slot: "card-detail" }, [
                _c("div", {
                  ref: "org",
                  staticClass:
                    "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                }),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(_vm.relate.component, {
                  tag: "component",
                  attrs: { componentHeight: _vm.height },
                  on: {
                    "update:componentHeight": function ($event) {
                      _vm.height = $event
                    },
                    "update:component-height": function ($event) {
                      _vm.height = $event
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(_vm.chem.component, {
                  tag: "component",
                  attrs: { componentHeight: _vm.height },
                  on: {
                    "update:componentHeight": function ($event) {
                      _vm.height = $event
                    },
                    "update:component-height": function ($event) {
                      _vm.height = $event
                    },
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }